
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    // 5초 후 자동으로 새 도메인으로 리다이렉트
    const timer = setTimeout(() => {
      window.location.href = 'https://iaiem.org';
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-slate-50 to-blue-50">
      {/* Header */}
      <header className="w-full py-6 px-4 bg-white/80 backdrop-blur-sm shadow-sm">
        <div className="max-w-4xl mx-auto flex justify-center">
          <img 
            src="https://static.readdy.ai/image/c85f69d10756a0d0650d8a410b24292d/406d8f3e7bbbb12f1a2dc248e9721e7c.png" 
            alt="AI혁신목회연구소 로고" 
            className="h-16 w-auto object-contain"
          />
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="max-w-2xl w-full">
          {/* Apology Message */}
          <section className="bg-white rounded-lg shadow-lg p-8 md:p-12 text-center">
            <div className="mb-6">
              <i className="ri-information-line text-6xl text-teal-600"></i>
            </div>
            
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">
              불편을 드려서 미안합니다
            </h1>
            
            <div className="space-y-4 text-gray-700 text-base md:text-lg mb-8">
              <p>
                회사명이 <strong className="text-teal-700">AI혁신목회연구소</strong>로 변경되었습니다.
              </p>
              <p className="text-sm text-gray-500">
                (구) AI목회컨설팅그룹 → (신) AI혁신목회연구소
              </p>
            </div>

            {/* Redirect Link */}
            <section className="space-y-4">
              <a 
                href="https://iaiem.org" 
                className="inline-flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
              >
                <span>새로운 홈페이지로 이동</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </a>
              
              <p className="text-sm text-gray-500">
                iaiem.org
              </p>
              
              <div className="flex items-center justify-center gap-2 text-sm text-gray-400 mt-6">
                <i className="ri-time-line"></i>
                <span>5초 후 자동으로 이동합니다...</span>
              </div>
            </section>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="w-full py-6 px-4 bg-white/80 backdrop-blur-sm border-t border-gray-200">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-sm text-gray-600">
            © 2025 AI혁신목회연구소. All rights reserved.
          </p>
          <p className="text-xs text-gray-500 mt-2">
            <a 
              href="https://readdy.ai/?ref=logo" 
              className="hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
              target="_blank"
              rel="noopener noreferrer"
            >
              Website Builder
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}
